import "core-js/modules/es.object.to-string.js";
import FormInput from '~/components/form/TextInput';
import { required, email } from 'vuelidate/lib/validators';
export default {
  name: 'PasswordRecoverPanel',
  components: {
    FormInput: FormInput
  },
  data: function data() {
    return {
      sent: false,
      email: ''
    };
  },
  validations: {
    email: {
      required: required,
      email: email,
      emailExists: function emailExists(value) {
        var _this = this;
        if (!this.$v.email.required || !this.$v.email.email) return false;
        return new Promise(function (resolve, reject) {
          _this.$axios.get('/user/checkemail', {
            params: {
              email: value
            }
          }).then(function (res) {
            resolve(!res.data.result);
          });
        });
      }
    }
  },
  computed: {
    emailError: function emailError() {
      var error = null;
      if (this.$v.email.$dirty && !this.$v.email.emailExists) error = this.$t('validation.emailExists');
      if (this.$v.email.$dirty && !this.$v.email.email) error = this.$t('validation.email');
      if (this.$v.email.$dirty && !this.$v.email.required) error = this.$t('validation.required');
      return error;
    },
    authPanelStore: function authPanelStore() {
      return useAuthPanelStore();
    },
    appStore: function appStore() {
      return useAppStore();
    }
  },
  methods: {
    changePanel: function changePanel() {
      this.authPanelStore.$patch({
        direction: 'right',
        state: 'login'
      });
    },
    send: function send(event) {
      var _this2 = this;
      event.preventDefault();
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.$axios.post('/user/restorepassword', {
        _csfr: this.appStore.csrfToken,
        email: this.email
      }).then(function () {
        _this2.sent = true;
        var toast = {
          title: _this2.$t('passwordRecover.resentTitle'),
          text: _this2.$t('passwordRecover.resentText'),
          icon: 'icon-ic-tick'
        };
        _this2.$toastStore.add(toast);
      }).catch(function (error) {
        var res = error.response ? error.response.data : null;
        var toast = {
          title: _this2.$t('passwordRecover.resentTitleError'),
          text: _this2.$t('passwordRecover.resentTextError'),
          icon: 'icon-ic-dismiss'
        };
        if (res) toast.text = res;
        _this2.$toastStore.add(toast);
      });
    }
  }
};